import React, { Component } from 'react';

class SamplePackBlankComponent extends Component {
    render() {
        return (
            <div>
              <div
                onClick={() => this.props.onClickCreate()}
                className="big-button">
                CREATE 
              </div>
              <div
                onClick={() => this.props.onClickView()}
                className="big-button">
                VIEW 
              </div>
            </div>
        );
    }
}

export default SamplePackBlankComponent;
